<script>
    import {MDCSwitch} from '@material/switch';
    import { onMount } from 'svelte';
    import { TS } from '../../config/translation-keys';
    import APIClient from '../../state-charts/api-client';
    import { show_message } from '../flash';
    import { t9n } from '../translate';

    export let value = false;
    export let label;
    export let id;
    export let bold_label = false;
    export let order = null;

    let switcher;

    const init_switcher = () => {
        let element = document.querySelector('#switcher-mdc');
        if(!!element){
            switcher = new MDCSwitch(element);
        }

    }

    const toggle_value = () => {
        value = !value;
    }

    const toggle_order = async (order) => {
        value = !value;
        let data = {
            "hide_order_on_cv": value,
            "order_uuid": order
        }
        await APIClient.hide_order_on_cv(data);
    }

    onMount(init_switcher);

</script>

<style>
    .mdc-switch{
        margin-right: 10px;
    }

    .bold-label{
        font-weight: bold;
    }
</style>

{#if order}
    <div class="mdc-switch"
         id='switcher-mdc'
         class:mdc-switch--checked={!value}
         on:click={async () => { await toggle_order(order) } }>
        <div class="mdc-switch__track"></div>
        <div class="mdc-switch__thumb-underlay">
            <div class="mdc-switch__thumb"></div>
            <input type="checkbox" id={id} class="mdc-switch__native-control" role="switch" aria-checked="false">
        </div>
    </div>
    <label for={id}
           class:bold-label={bold_label}>
        {label}
    </label>
{:else}
    <div class="mdc-switch"
         id='switcher-mdc'
         class:mdc-switch--checked={value}
         on:click={() => toggle_value()}>
        <div class="mdc-switch__track"></div>
        <div class="mdc-switch__thumb-underlay">
            <div class="mdc-switch__thumb"></div>
            <input type="checkbox" id={id} class="mdc-switch__native-control" role="switch" aria-checked="false">
        </div>
    </div>
    <label for={id}
           class:bold-label={bold_label}>
        {label}
    </label>
{/if}